export const data: any = {
  revenue: {
    children: [
      {
        param: "products",
        uom: "",
        target: "",
        ytd: "",
        dataSource: "",
        value: "",
        attachments: [],
        comments: "",
      },
      {
        param: "turnover",
        uom: "",
        target: "",
        ytd: "",
        dataSource: "",
        value: "",
        attachments: [],
        comments: "",
      },
    ],
  },
  environment: {
    param: "Total Production",
    uom: "MT",
    target: "",
    ytd: "",
    dataSource: "",
    value: "",
    attachments: [],
    comments: "",
    children: [
      {
        title: "Green House Gases & Energy Footprint",
        children: {
          A: {
            title:
              "Energy consumption source producing Direct Emission (Scope 1 Emission)",
            children: [
              {
                SNO: "I",
                param: "LPG",
                uom: "MT",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
              {
                SNO: "II",
                param: "Coal (Anthracite)",
                uom: "MT",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
              {
                SNO: "III",
                param: "Coal (Lignite)",
                uom: "MT",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
              {
                SNO: "IV",
                param: "Natural Gas",
                uom: "M3",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
              {
                SNO: "V",
                param: "High Speed Diesel (HSD)",
                uom: "KL",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
              {
                SNO: "VI",
                param: "Petrol",
                uom: "KL",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
              {
                SNO: "VII",
                param: "Biomass (Renewables)",
                uom: "MT",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
              {
                SNO: "VIII",
                param: "Bio-fuel (Renewables)",
                uom: "KL",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
              {
                SNO: "IX",
                param: "Furnace Oil",
                uom: "KL",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
              {
                SNO: "X",
                param: "Light Diesel Oil",
                uom: "KL",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
              {
                SNO: "XI",
                param: "Acetylene",
                uom: "M3",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },

              {
                SNO: "XII",
                param: "Referigerants (Input only annual data)",
                uom: "MT",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
            ],
          },
          B: {
            title:
              "Energy consumption source producing Indirect Emission (Scope 2 Emission)",
            children: [
              {
                SNO: "I",
                param: "Electricity from Grid",
                uom: "kWh",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },

              {
                SNO: "II",
                param: "Electricity from Renewables",
                uom: "kWh",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
            ],
          },
          C: {
            title: "Supplier Carbon Emissions & Energy Footprint",
            children: [
              {
                SNO: "I",
                param: "Total Scope 1 Carbon Emissions",
                uom: "TCO2e",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },

              {
                SNO: "II",
                param: "Total Scope 2 Emissions",
                uom: "TCO2e",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
              {
                SNO: "III",
                param: "Energy Footprint",
                uom: "GJ",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
            ],
          },

          D: {
            title: "Supplier Carbon Emission & Energy KPI",
            children: [
              {
                SNO: "I",
                param: "Absolute Carbon emission",
                uom: "TCO2e",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },

              {
                SNO: "II",
                param: "Carbon Emission Intensity",
                uom: "TCO2e/MT of Production",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
              {
                SNO: "III",
                param: "Energy Intensity",
                uom: "GJ/MT of Production",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
            ],
          },
        },
      },
      {
        title: "Water Footprint",
        children: {
          A: {
            title: "Input Water (Fresh Water)",
            children: [
              {
                SNO: "I",
                param: "Ground Water",
                uom: "KL",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },

              {
                SNO: "II",
                param: "Surface Water",
                uom: "KL",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
              {
                SNO: "III",
                param: "Municipal Water",
                uom: "KL",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
              {
                SNO: "IV",
                param: "Other sources",
                uom: "KL",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
            ],
          },
          B: {
            title: "Output Water",
            children: [
              {
                SNO: "I",
                param: "Total Waste Water Discharged",
                uom: "KL",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },

              {
                SNO: "II",
                param: "Total Water Recycled / Re-used",
                uom: "KL",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
            ],
          },
          C: {
            title: "Water Consumption",
            children: [
              {
                SNO: "I",
                param: "Fresh Water Consumption (Sum of Input Water)",
                uom: "KL",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },

              {
                SNO: "II",
                param:
                  "Total Water Consumption (Fresh Water Consumption + Water Recycled / Re-used)",
                uom: "KL",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
            ],
          },
          D: {
            title: "Supplier Water KPI",
            children: [
              {
                SNO: "I",
                param: "Water Intensity (Fresh Water)",
                uom: "KL/MT of Production",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
            ],
          },
        },
      },
      {
        title: "Waste Disposal",
        children: {
          A: {
            title: "Hazardous Waste",
            children: [
              {
                SNO: "I",
                param: "Waste Generated(Waste leaving Plant boundary)",
                uom: "MT",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },

              {
                SNO: "II",
                param: "Waste Disposed-Lanfill/Incineration",
                uom: "MT",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
              {
                SNO: "III",
                param: "Waste Disposed-Lanfill/Incineration",
                uom: "MT",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
            ],
          },
          B: {
            title: "Non Hazardous Waste",
            children: [
              {
                SNO: "I",
                param: "Waste Generated(Waste leaving Plant boundary)",
                uom: "KL",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },

              {
                SNO: "II",
                param: "Waste Disposed-Lanfill/Incineration",
                uom: "KL",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
              {
                SNO: "III",
                param: "Waste Recycled/Re-used",
                uom: "MT",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
            ],
          },
          C: {
            title: "Supplier Waste Footprint",
            children: [
              {
                SNO: "I",
                param: "Total waste Generated",
                uom: "MT",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
            ],
          },
          D: {
            title: "Supplier Waste KPI",
            children: [
              {
                SNO: "I",
                param: "Waste Intensity",
                uom: "MT/ MT of Production",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
            ],
          },
        },
      },
    ],
  },
  health: {
    children: [
      {
        title:
          "Details of safety related incidents for employees and workers (including contract-workforce)",
        children: {
          A: {
            title: "Details of safety related incidents ",
            children: [
              {
                SNO: "I",
                param: "Total Manhours worked",
                uom: "Nos of Hours",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },

              {
                SNO: "II",
                param: "No of recordable incidents",
                uom: "Nos",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
              {
                SNO: "III",
                param: "No of Lost Time Incidents (LTIs)",
                uom: "Nos of Hours",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
              {
                SNO: "IV",
                param: "No of fatalities",
                uom: "Nos",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
            ],
          },
          B: {
            title: "Safety KPI",
            children: [
              {
                SNO: "I",
                param: "Lost Time Frequency Rate (LTIFR)",
                uom: "",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },

              {
                SNO: "II",
                param: "No of fatalities",
                uom: "",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
            ],
          },
        },
      },
    ],
  },

  assurance: {
    children: [
      {
        children: {
          A: {
            title: "Licenses Validity & Certifications",
            children: [
              {
                SNO: "I",
                param: "Valid Factory licenses",
                uom: "",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
                boolean: true,
              },

              {
                SNO: "II",
                param: "Valid Environmental Consents (EC / CTE / CTO)",
                uom: "",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
                boolean: true,
              },
              {
                SNO: "III",
                param: "Valid PESO licenses",
                uom: "",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
                boolean: true,
              },
              {
                SNO: "IV",
                param:
                  "Availability of mandated Pollution Control Equipment as per CTO",
                uom: "",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
                boolean: true,
              },
              {
                SNO: "V",
                param: "No fines / show cause notices during the month",
                uom: "",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
                boolean: true,
              },
              {
                SNO: "VI",
                param: "ISO 14001 / ISO 45001 Certification",
                uom: "",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
                boolean: true,
              },
            ],
          },
          B: {
            title: "Other Information",
            children: [
              {
                SNO: "I",
                param: "EHS audits conducted",
                uom: "",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },

              {
                SNO: "II",
                param: "Showcause notices/Fines/Penalties",
                uom: "",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
              {
                SNO: "III",
                param: "Employee EHS Trainings",
                uom: "",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
              {
                SNO: "IV",
                param: "Any other achievement",
                uom: "",
                target: "",
                ytd: "",
                dataSource: "",
                value: "",
                attachments: [],
                comments: "",
              },
            ],
          },
        },
      },
    ],
  },
};

export const factorData: any = {
  LPG: {
    emission: 2.94,
    energy: 50.28,
  },
  "Coal (Anthracite)": {
    emission: 2.87,
    energy: 29.18,
  },
  "Coal (Lignite)": {
    emission: 1.53,
    energy: 16.53,
  },
  "Natural Gas": {
    emission: 0.002,
    energy: 0.0382,
  },
  "High Speed Diesel (HSD)": {
    emission: 2.697,
    energy: 37.92,
  },
  Petrol: {
    emission: 2.32,
    energy: 34.84,
  },
  "Biomass (Renewables)": {
    emission: 0,
    energy: 9.59,
  },
  "Bio-fuel (Renewables)": {
    emission: 0,
    energy: 35.68,
  },
  "Furnace Oil": {
    emission: 2.98,
    energy: 41.81,
  },
  "Light Diesel Oil": {
    emission: 2.66,
    energy: 35.91,
  },
  Acetylene: {
    emission: 0.0039,
    energy: 0.0569,
  },
  "Referigerants (Input only annual data)": {
    emission: 0,
    energy: 0,
  },
  "Electricity from Grid": {
    emission: 0.00071,
    energy: 0.0036,
  },
  "Electricity from Renewables": {
    emission: 0,
    energy: 0.0036,
  },
};
